import { render, staticRenderFns } from "./DetilSimulasi.vue?vue&type=template&id=d7f945ca&scoped=true&"
import script from "./DetilSimulasi.vue?vue&type=script&lang=js&"
export * from "./DetilSimulasi.vue?vue&type=script&lang=js&"
import style0 from "./DetilSimulasi.vue?vue&type=style&index=0&id=d7f945ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f945ca",
  null
  
)

export default component.exports